import { TRIGGER_TYPE_LABEL } from "../../../features/builder.constants";
import apiReminderRecipientType from "../api";

const extract = (res) => (res.status === "fulfilled" ? res.value?.data?.data || [] : []);

// Dropdown data of the recipient type form: the resolvers (`id` = type_key for the select) and the trigger types.
export const loadRecipientTypeDependencies = async () => {
  const [resolversRes] = await Promise.allSettled([apiReminderRecipientType.getResolvers()]);
  return {
    resolvers: extract(resolversRes).map((resolver) => ({ ...resolver, id: resolver.type_key })),
    triggerTypes: Object.entries(TRIGGER_TYPE_LABEL).map(([id, label]) => ({ id, label })),
  };
};
